export default __webpack_public_path__ + "static/media/icon_cerrar_green.2ee61f66.svg";